import {
    DateOptions,
    getPresetRanges as originalGetPresetRanges,
    findDateRangeFromPreset
} from '@agyletime/vue-3-common/src/utils/preset';

export const getPresetRanges = (options: DateOptions) => {
    // Return all presets including Tomorrow, Next week, and Next month
    // to match the Angular reference implementation
    const presets = originalGetPresetRanges(options);
    
    // Add "Custom Range" option at the end
    return [
        ...presets,
        {
            label: 'Custom Range',
            value: [] // Empty value indicates custom range
        }
    ];
};
import { differenceInSeconds } from 'date-fns';

export const getDateRange = (date: string | string[]) => {
    if (date && typeof date === 'string') {
        const weekOptions: DateOptions = { weekStartsOn: 1 };
        const presetRanges = getPresetRanges(weekOptions);
        return findDateRangeFromPreset({ preset: date }, presetRanges);
    }
    return date as string[];
};

export const validateDateRange = (startDate: Date, endDate: Date, rangeInSecs: number): boolean => {
    return differenceInSeconds(new Date(endDate), new Date(startDate)) > rangeInSecs ? false : true;
};
